export default {
  title: "Pago por uso",
  subtitle: "Compre créditos según necesite, no se requiere suscripción",
  calculation_title: "Cálculos de emisiones de carbono",
  report_title: "Informes",
  combo_title: "Paquetes combinados",
  combo_subtitle: "Ahorre más con nuestros paquetes combinados",
  select_quantity: "Seleccionar cantidad",
  select_package: "Seleccionar paquete",
  total: "Total",
  calculation_credits: "Créditos de cálculo",
  report_credits: "Créditos de informe",
  credits: "Créditos",
  price: "Precio",
  buy_now: "Comprar ahora",
  starter_pack: "Paquete inicial",
  professional_pack: "Paquete profesional",
  enterprise_pack: "Paquete empresarial",
  save_x_percent: "Ahorre {percent}%",
  note: "Los créditos que compre nunca expiran.",
  expiry_note:
    "Puede usarlos en cualquier momento. En el futuro, habrá funciones opcionales de extensión o conversión de créditos disponibles.",
  calculation_price: "Cálculos de emisiones de carbono",
  report_price: "Informes",
  calculation_price_dynamic: "{price} por cálculo",
  report_price_dynamic: "{price} por informe",
  benefits: "Beneficios del pago por uso",
  future_features: "Funciones futuras",
  future_features_desc:
    "Planeamos introducir funciones opcionales de extensión y cambio de créditos en el futuro. Actualmente no se requiere ninguna acción.",
  extension_option_future: "Extensión de créditos",
  extension_option_future_desc:
    "Extienda la validez de sus créditos por una tarifa baja (disponible en una versión futura).",
  credit_exchange_future: "Cambio de créditos",
  credit_exchange_future_desc:
    "Cambie créditos no utilizados o expirados por acceso de prueba en versiones futuras.",
  quantity: "Cantidad",
  ladder_pricing: "Precios escalonados",
  unit: "Unidad",
  pay_per_use_benefit1: "No se requiere suscripción",
  pay_per_use_benefit2: "Solo pague por lo que use",
  pay_per_use_benefit3: "Vitalicio",
};
